import * as React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { State } from "../store/types";

interface Props {
  authenticated: boolean;
}

const AnonymousOnly: React.FC<Props> = props => {
  if (props.authenticated) {
    return <Redirect push={true} to="/" />;
  }

  return <>{props.children}</>;
};

function mapStateToProps(state: State) {
  return {
    authenticated: state.auth.authenticated
  };
}

export default connect(mapStateToProps)(AnonymousOnly);
